import { __values } from "tslib";
import { escapeUri } from "./escape-uri";
export function escapeUriPath(uri) {
    var e_1, _a;
    var parts = [];
    try {
        for (var _b = __values(uri.split("/")), _c = _b.next(); !_c.done; _c = _b.next()) {
            var sub = _c.value;
            parts.push(escapeUri(sub));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parts.join("/");
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXVyaS1wYXRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VzY2FwZS11cmktcGF0aC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUN6QyxNQUFNLFVBQVUsYUFBYSxDQUFDLEdBQVc7O0lBQ3ZDLElBQU0sS0FBSyxHQUFhLEVBQUUsQ0FBQzs7UUFDM0IsS0FBa0IsSUFBQSxLQUFBLFNBQUEsR0FBRyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQSxnQkFBQSw0QkFBRTtZQUE3QixJQUFNLEdBQUcsV0FBQTtZQUNaLEtBQUssQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7U0FDNUI7Ozs7Ozs7OztJQUNELE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUN6QixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZXNjYXBlVXJpIH0gZnJvbSBcIi4vZXNjYXBlLXVyaVwiO1xuZXhwb3J0IGZ1bmN0aW9uIGVzY2FwZVVyaVBhdGgodXJpOiBzdHJpbmcpOiBzdHJpbmcge1xuICBjb25zdCBwYXJ0czogc3RyaW5nW10gPSBbXTtcbiAgZm9yIChjb25zdCBzdWIgb2YgdXJpLnNwbGl0KFwiL1wiKSkge1xuICAgIHBhcnRzLnB1c2goZXNjYXBlVXJpKHN1YikpO1xuICB9XG4gIHJldHVybiBwYXJ0cy5qb2luKFwiL1wiKTtcbn1cbiJdfQ==